module.exports = __webpack_public_path__ + "static/images/pricing-full.54144f0ba8db2a3f9f8f0ba68d1577d8.svg";